import { AddIcon } from '@chakra-ui/icons';
import { HStack, IconButton, Text } from '@chakra-ui/react';
import { FC } from 'react';

type Props = {
  label: string;
  onClick: () => void;
};

export const AddIconButton: FC<Props> = ({ label, onClick }) => (
  <HStack gap="5px">
    <IconButton onClick={onClick} aria-label={label} icon={<AddIcon />} />
    <Text>{label}</Text>
  </HStack>
);
